import { render, staticRenderFns } from "./MiniQuiz.vue?vue&type=template&id=7e8ce5a0&"
import script from "./MiniQuiz.vue?vue&type=script&lang=js&"
export * from "./MiniQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports